export default __webpack_public_path__ + "static/media/mousai_detail_logo.f11aa98e.png";